import { animate, state, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from 'src/app/_services/notification.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { ConfirmDeleteDialogComponent } from 'src/app/gestion-usuarios/dialogs/confirm-delete-dialog.component';
import { ConfirmUpdateDialogComponent } from 'src/app/modal/confirmar-update/confirm-update-dialog/confirm-update-dialog.component';
import { Campo, Opcion, Pestania, ProcedimientoDinamico, TramiteImportResumen, TramiteTransferBundle } from 'src/app/model/procedimiendo-dinamico';
import { Procedimiento } from 'src/app/model/procedimiento';
import { environment } from 'src/environments/environment';
import { ProcedimientosService } from '../../_services/procedimientos.service';

@Component({
  selector: 'app-listado-procedimientos-dinamicos',
  templateUrl: './listado-procedimientos-dinamicos.component.html',
  styleUrls: ['./listado-procedimientos-dinamicos.component.scss'],
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        height: '600px',
        opacity: 1,
      })),
      state('closed', style({
        height: '65px',
        opacity: 0.8,
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ],
})
export class ListadoProcedimientosDinamicosComponent implements OnInit {
  displayedColumns: string[] = ['departamento.nombre', 'nombre', 'fechaAlta', 'acciones'];

  // El listado vive dentro de *ngIf="!creandoProc": al abrir el builder el
  // paginador/sort se destruyen y al volver se crean instancias nuevas. Los
  // setters re-vinculan el dataSource a la instancia recién creada; sin esto
  // el paginador queda apuntando a la destruida y muestra "0 de 0".
  sort: MatSort;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.sort = sort;
    if (this.dataSource && sort) this.dataSource.sort = sort;
  }

  paginator: MatPaginator;
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    this.paginator = paginator;
    if (this.dataSource && paginator) this.dataSource.paginator = paginator;
  }
  indexToEdit: number = undefined;
  constructor(
    private procedimientosService: ProcedimientosService,
    private router: Router,
    public dialog: MatDialog,
    private paginatorIntl: MatPaginatorIntl,
    private formBuilder: FormBuilder,
    private _servicioGeneral: ServicioGeneral,
    private notificationService: NotificationService,
    private translate: TranslateService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.currentEnv = environment.environment;
    this.traduccionPaginator();
  }
  creandoProc: boolean = false;
  editingProcId: number | null = null;
  formFechaCierre = new UntypedFormGroup({
    fecha: new UntypedFormControl(""),
    hora: new UntypedFormControl(""),
  })

  formFechaApertura = new UntypedFormGroup({
    fecha: new UntypedFormControl(""),
    hora: new UntypedFormControl(""),
  })

  ngOnInit(): void {
    this.getProcedimientos();
    this.loadDestinosTransfer();
  }

  /** GMU: los trámites se crean ocultos para el ciudadano (visible=false). */
  readonly esGmu = environment.environment === 'gmu';

  procedimientos: Array<any> = [];
  procedimientosVisibles: any = [];
  dataSource = new MatTableDataSource<Procedimiento>();
  currentEnv: string;

  get totalProcedimientos(): number { return this.dataSource?.data?.length || 0; }
  get procedimientosActivos(): number {
    return (this.dataSource?.data || []).filter((p: any) => p.visible).length;
  }
  get procedimientosInactivos(): number {
    return this.totalProcedimientos - this.procedimientosActivos;
  }

  procedimientoEdicion: ProcedimientoDinamico;
  TDepartamentos: any = [];
  listadonNombreCampo: any = [];
  listadonNombreVariable: any = [];
  listadoListaDisponible: any = [];
  isOpen = true;
  panelDatosTramite: boolean = true;
  panelPestanias: boolean = false;
  panelCampo: boolean = false;
  pasoTramite: string = 'datosTramite';
  tabIndexSelected: number = 0;
  listadoComponentes: any = [{ label: 'text' }, { label: 'file' }, { label: 'checkbox' }, { label: 'select' }, { label: 'textarea' }, { label: 'multiselect' }];
  listadoValidadores: any = [{ label: '' }, { label: 'Pattern' }];
  nuevoListado: boolean = false;
  modificarListado: boolean = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }
  async getProcedimientos() {
    await this.procedimientosService.getProcedimientos().subscribe({
      next: (data) => {

        this.procedimientos = data['Procedimiento'];
        if (this.procedimientos != undefined || this.procedimientos.length != 0) {
          this.procedimientos = this.procedimientos.filter(procedimiento => procedimiento.fechaBaja == null && procedimiento.custom);
          this.dataSource = new MatTableDataSource(this.procedimientos)
          this.dataSource.paginator = this.paginator;
          this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'departamento.nombre': return item.departamento.nombre;
              default: return item[property];
            }
          }
          this.dataSource.sort = this.sort;
        }
      },
      error: (err) => {
        //console.log(err);
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  crearNuevoTramite() {
    this.editingProcId = null;
    this.creandoProc = true;
  }

  editarTramite(procedimiento: Procedimiento) {
    this.editingProcId = procedimiento.id;
    this.creandoProc = true;
  }

  onBuilderClose(event: { saved: boolean }) {
    this.creandoProc = false;
    this.editingProcId = null;
    if (event?.saved) {
      this.getProcedimientos();
    }
  }
  cancelar() {
    this.creandoProc = false;
  }
  finalizarTramite() {
    if (this.procedimientoForm.valid) {
      this.procedimientosService.guardaProcedimiento(this.mapFormProcedimiento(this.procedimientoForm)).subscribe(
        {
          next: (data) => {
            if (data && data['id']) {
              this.procedimientoForm.patchValue({
                id: data['id']
              });
            }
            this.creandoProc = false;
            this.getProcedimientos();
            this.notificationService.success(this.translate.instant('COMMON.SAVED'), this.translate.instant('PROCEDIMIENTOS.MSG.SAVED'), 5000);
          },
          error: (err) => {
            this.notificationService.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROCEDIMIENTOS.MSG.SAVE_FAIL'), 5000);
          }
        }
      );
    } else {
      // Marcar todos los campos como tocados para mostrar mensajes de error
      this.procedimientoForm.markAllAsTouched();
    }


  }
  openDeleteDialog(procedimiento: ProcedimientoDinamico) {
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: this.translate.instant('PROCEDIMIENTOS.MSG.DELETE_TITLE'),
        message: this.translate.instant('PROCEDIMIENTOS.MSG.DELETE_MSG', { nombre: procedimiento.nombre || '' }),
        confirmLabel: this.translate.instant('COMMON.DELETE')
      },
      panelClass: 'gu-dialog-panel'
    });
    return ref.afterClosed().subscribe((ok) => {
      if (!ok || procedimiento.id == null) return;
      this.borrarProcedimiento(procedimiento.id).then(() => {
        this.reloadToMenuOption();
      });
    });
  }
  openCopyDialog(id: Number) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = { titulo: "Copiar trámite" }

    const dialogRef = this.dialog.open(ConfirmUpdateDialogComponent, dialogConfig);
    return dialogRef.afterClosed().subscribe(result => {
      if (result.result == 'Confirmar') {
        this.copiarProcedimiento(id).then(() => {
          this.reloadToMenuOption()
        });
      }
    })
  }
  async borrarProcedimiento(id: Number) {
    await firstValueFrom(this.procedimientosService.borrarProcedimiento(id)).then((data) => {

    });
  }
  async copiarProcedimiento(id: Number) {
    await firstValueFrom(this.procedimientosService.copiarProcedimiento(id)).then((data) => {

    });
  }

  // ---- Transferencia de trámites entre entornos ----

  /** Entornos destino configurados en el back (properties). */
  destinosTransfer: string[] = [];
  importandoTramite = false;

  private loadDestinosTransfer(): void {
    this.procedimientosService.getDestinosTransfer().subscribe({
      next: (data) => {
        this.destinosTransfer = data?.['destinos'] ?? [];
      },
      error: () => {
        this.destinosTransfer = [];
      }
    });
  }

  exportarTramite(procedimiento: any): void {
    this.procedimientosService.exportarTramite(procedimiento.id).subscribe({
      next: (bundle) => {
        const nombreFichero = `tramite-${procedimiento.codigo || procedimiento.id}.json`;
        const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = nombreFichero;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.notificationService.success(this.translate.instant('COMMON.EXPORTED'), this.translate.instant('PROCEDIMIENTOS.MSG.EXPORTED', { file: nombreFichero }), 5000);
      },
      error: () => {
        this.notificationService.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROCEDIMIENTOS.MSG.EXPORT_FAIL'), 5000);
      }
    });
  }

  onImportFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    // permitir volver a seleccionar el mismo fichero más adelante
    input.value = '';
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      let bundle: TramiteTransferBundle;
      try {
        bundle = JSON.parse(reader.result as string);
      } catch {
        this.notificationService.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROCEDIMIENTOS.MSG.JSON_INVALID'), 5000);
        return;
      }
      if (!bundle?.formatVersion || (!bundle?.procedimiento?.Codigo && !bundle?.procedimiento?.codigo)) {
        this.notificationService.error(
          this.translate.instant('COMMON.ERROR'),
          'El fichero no es un export de trámite dinámico (falta formatVersion o procedimiento)',
          6000
        );
        return;
      }
      this.importarTramite(bundle);
    };
    reader.readAsText(file);
  }

  private importarTramite(bundle: TramiteTransferBundle): void {
    this.importandoTramite = true;
    this.procedimientosService.importarTramite(bundle).subscribe({
      next: (resumen: TramiteImportResumen) => {
        this.importandoTramite = false;
        const apiDetalle = (resumen as any)?.detalle;
        const codigo = resumen?.codigo ?? '';
        let detalle = apiDetalle || (`Trámite ${codigo} importado sin publicar con ` +
          `${resumen?.pestanias ?? 0} pestaña(s) y ${resumen?.campos ?? 0} campo(s).`);
        if (!apiDetalle) {
          if ((resumen?.listadosCreados ?? []).length > 0) {
            detalle += ` Listados creados: ${resumen.listadosCreados.join(', ')}.`;
          }
          if ((resumen?.listadosReutilizados ?? []).length > 0) {
            detalle += ` Listados reutilizados (idénticos en destino): ${resumen.listadosReutilizados.join(', ')}.`;
          }
          if ((resumen?.listadosRenombrados ?? []).length > 0) {
            detalle += ` Listados creados en paralelo por existir con distinto contenido: ${resumen.listadosRenombrados.join(', ')}.`;
          }
          if (resumen?.departamentoCreado) {
            detalle += ' Se ha creado el departamento.';
          }
          if (resumen?.codigoYaExistia) {
            detalle += ' Atención: ya existía un trámite con ese código.';
          }
        }
        this.notificationService.success(this.translate.instant('COMMON.IMPORTED'), detalle, 8000);
        this.getProcedimientos();
      },
      error: () => {
        this.importandoTramite = false;
        this.notificationService.error(this.translate.instant('COMMON.ERROR'), this.translate.instant('PROCEDIMIENTOS.MSG.IMPORT_FAIL'), 5000);
      }
    });
  }

  openEnviarEntornoDialog(procedimiento: any, destino: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = '25vw';
    dialogConfig.minWidth = '500px';
    dialogConfig.data = { titulo: `envío de «${procedimiento.nombre}» al entorno ${destino}` };

    const dialogRef = this.dialog.open(ConfirmUpdateDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result?.result == 'Confirmar') {
        this.enviarTramiteEntorno(procedimiento, destino);
      }
    });
  }

  private enviarTramiteEntorno(procedimiento: any, destino: string): void {
    this.procedimientosService.enviarTramiteEntorno(procedimiento.id, destino).subscribe({
      next: (data) => {
        const resumen = data?.resultado;
        const apiDetalle = (data as any)?.detalle || (resumen as any)?.detalle;
        let detalle = apiDetalle || `Trámite «${procedimiento.nombre}» enviado a ${destino} sin publicar.`;
        if (!apiDetalle && resumen?.codigoYaExistia) {
          detalle += ' Atención: en el destino ya existía un trámite con ese código.';
        }
        this.notificationService.success(this.translate.instant('COMMON.SENT'), detalle, 8000);
      },
      error: () => {
        this.notificationService.error(
          this.translate.instant('COMMON.ERROR'),
          `No se pudo enviar el trámite al entorno ${destino}`,
          6000
        );
      }
    });
  }
  refresh() {
    this.procedimientosService.getProcedimientos().subscribe((data: Procedimiento[]) => {
      this.dataSource.data = data;
    });
  }

  scrollTop() {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  reloadToMenuOption() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.scrollTop();
    this.router.navigate(['/admin'], { queryParams: { action: 35 } });

  }
  private traduccionPaginator(): void {
    this.paginatorIntl.itemsPerPageLabel = "Registros por página";
    this.paginatorIntl.firstPageLabel = '';
    this.paginatorIntl.previousPageLabel = '';
    this.paginatorIntl.nextPageLabel = '';
    this.paginatorIntl.lastPageLabel = '';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }

  procedimientoForm: FormGroup;

  pestaniaForm: FormGroup;

  campoForm: FormGroup;

  opcionForm: FormGroup;

  initForm(): void {
    this.procedimientoForm = this.formBuilder.group({
      id: [null],
      nombre: ['', Validators.required],
      codigo: ['', Validators.required],
      sia: [null, [Validators.required, Validators.pattern('^[0-9]{1,9}$')]],
      identificador: [null, [Validators.required, Validators.pattern('^[0-9]{1,9}$')]],
      visible: [false, Validators.required],
      link_ayuda: [''],
      link_ordenanza: [''],
      departamento: this.formBuilder.group({
        id: [null, Validators.required]
      }),
      custom: [true],
      pestanias: this.formBuilder.array([])
    });
    this.procedimientoForm.markAsUntouched();
    this.pestaniaForm = this.formBuilder.group({});
    this.pestaniaForm.markAsUntouched();
    this.campoForm = this.formBuilder.group({});
    this.campoForm.markAsUntouched();
    this.pasoTramite = 'datosTramite';
  }
  initFormEdit(procedimiento: any): void {

    this.procedimientoForm = this.formBuilder.group({
      id: [procedimiento['id']],
      nombre: [procedimiento['nombre'], Validators.required],
      codigo: [procedimiento['codigo'], Validators.required],
      sia: [procedimiento['sia'], [Validators.required, Validators.pattern('^[0-9]{1,9}$')]],
      identificador: [procedimiento['identificador'], [Validators.required, Validators.pattern('^[0-9]{1,9}$')]],
      visible: [procedimiento['visible'], Validators.required],
      link_ayuda: [procedimiento['link_ayuda']],
      link_ordenanza: [procedimiento['link_ordenanza']],
      departamento: this.formBuilder.group({
        id: [procedimiento['departamento']['id'], Validators.required]
      }),
      custom: [procedimiento['custom']],
      pestanias: this.inicializaPestanias(procedimiento)
    });
    this.ordenaArrayPestanias();
    this.actualizaIndexSelectedB(0, false);
    this.procedimientoForm.markAsUntouched();
  }
  inicializaPestanias(procedimiento: any): FormArray {
    var arrayPestanias: FormArray = this.formBuilder.array([]);

    if (procedimiento.pestanias) {
      procedimiento.pestanias.forEach(pest => {
        console.log("Pest: ", pest);

        var formPestaniaNew: FormGroup = this.formBuilder.group({
          id: [pest.id],
          nombre: [pest.nombre, Validators.required],
          titulo: [pest.titulo],
          tagId: [pest.tagId, [Validators.required, Validators.pattern('^[A-z,0-9]{1,255}$')]],
          orden: [pest.orden, Validators.required],
          visible: [pest.visible, Validators.required],
          campos: this.inicializaCampos(pest)
        });
        arrayPestanias.controls.push(formPestaniaNew);
      });
      //if(!this.pasoTramite)this.pasoTramite = 'datosPestanias';
    }
    else {
      if (!this.pasoTramite) this.pasoTramite = 'datosTramite';

    }
    return arrayPestanias;
  }

  inicializaCampos(pestania: any): FormArray {
    var arrayCampos: FormArray = this.formBuilder.array([]);

    if (pestania.campos) {
      pestania.campos.forEach(campo => {

        var formCampoNew: FormGroup = this.formBuilder.group({
          id: [campo.id],
          tipo: [campo.tipo, Validators.required],
          label: [campo.label],
          textoRepresentativo: [campo.textoRepresentativo],
          nombre: [campo.nombre, Validators.required],
          valor: [campo.valor],
          orden: [campo.orden, Validators.required],
          visible: [campo.visible, Validators.required],
          habilitado: [campo.habilitado, Validators.required],
          tipovalidador: [campo.tipovalidador],
          patternvalidador: [campo.patternvalidador],
          obligatorio: [campo.obligatorio, Validators.required],
          divClass: [campo.divClass],
          nombreVariableDefecto: [campo.nombreVariableDefecto],
          nombreCampoDefecto: [campo.nombreCampoDefecto],
          nuevoListado: [false],
          modificarListado: [false],
          listado: [campo.listado],
          listadoSeleccionado: [campo.listadoSeleccionado],
          listadoinicial: [campo.listadoinicial],
          tituloEnfatizado: [campo.tituloEnfatizado]
        });
        arrayCampos.controls.push(formCampoNew);
      });
      this.pasoTramite = 'datosCampo';
    }
    return arrayCampos;
  }
  getDepartamentos() {
    return this._servicioGeneral.getDepartamentos().subscribe((data) => {
      this.TDepartamentos = data['departamentos'];
    });
  }

  getListadoNombreVariable() {
    return this.procedimientosService.getListaByLista("nombreVariable").subscribe((data) => {
      this.listadonNombreVariable = data['listado'];
    });
  }


  async getListadoNombreVariableByargumento(argumento): Promise<any> {
    return new Promise<any>((resolve) => {
      this.procedimientosService.getListaByLista(argumento).subscribe(
        data => {
          console.log(data)
          resolve(data['listado']);
        },
        err => {
          resolve(err);
        }
      );
    })
  }

  ;


  getListadoNombreCampo() {
    return this.procedimientosService.getListaByLista("nombreCampo").subscribe((data) => {
      console.log("Lista by lista: ", data);

      this.listadonNombreCampo = data['listado'];
    });
  }
  getListasDisponibles() {
    return this.procedimientosService.getListasDisponibles().subscribe((data) => {
      this.listadoListaDisponible = data['listas'];
    });
  }




  get departamentos(): FormArray {
    return this.procedimientoForm.get('departamento.departamentos') as FormArray;
  }

  addDepartamento(): void {
    this.departamentos.push(this.formBuilder.control(''));
  }

  get pestanias(): FormArray {
    return this.procedimientoForm.get('pestanias') as FormArray;
  }

  get pestaniaActual(): FormGroup {
    return (this.procedimientoForm.get('pestanias') as FormArray).controls[this.tabIndexSelected] as FormGroup;
  }

  ordenaArrayPestanias(): void {
    const pestanias = this.procedimientoForm.get('pestanias') as FormArray;

    this.procedimientoForm.controls['pestanias'] = this.formBuilder.array(
      this.sortArray(pestanias.controls as FormGroup[], 'orden')
    );
  }

  ordenaArrayCampos(campos: FormArray): FormArray {
    if (campos) {
      return this.formBuilder.array(
        this.sortArray(campos.controls as FormGroup[], 'orden')
      );
    }
    else {
      return campos;
    }
  }

  sortArray(array: Array<FormGroup>, prop: string): Array<any> {
    return array.sort((a, b) => {
      prop.split('.').forEach(p => {
        a = a.controls[p]?.value;
        b = b.controls[p]?.value;
      });

      return (a > b) ? 1 : ((b > a) ? -1 : 0);
    });
  }

  pestaniaAsFormGroup(form: any): FormGroup {
    return form as FormGroup;
  }

  addPestania(): void {
    this.pestanias.push(this.initPestania());
  }

  addPestaniaGroup(): void {
    var proc: any = this.pestanias.controls.findIndex(pest => this.asFormGroup(pest).controls['id']?.value == this.pestaniaForm.controls['id']?.value);
    if (proc >= 0) {
      this.pestanias[proc] = this.pestaniaForm;
    }
    else {
      this.pestanias.push(this.pestaniaForm);
    }
  }

  removePestania(index: number): void {

    this.procedimientosService.bajaPestaniaProcedimiento(this.mapFormPestania((this.pestanias.controls[index] as FormGroup))).subscribe(
      {
        next: (data) => {
          var orden: number = (this.pestanias.controls[index] as FormGroup).controls['orden'].value;
          this.pestanias.controls.forEach(element => {
            if (orden < element.get('orden')?.value) {
              element.get('orden')?.setValue(element.get('orden')?.value - 1);
              this.procedimientosService.guardaPestaniaProcedimiento(this.procedimientoForm.controls['id'].value, this.mapFormPestania(element as FormGroup)).subscribe(
                {
                  next: (data) => {
                  },
                  error: (err) => {
                  }
                }
              );
            }
          });
          this.pestanias.removeAt(index);
          if (this.pestanias.length == 0) {
            this.pasoTramite = 'datosPestanias';
            this.pestaniaForm = this.initPestania();
            this.campoForm = this.formBuilder.group({});
          } else if (index == this.tabIndexSelected) this.actualizaIndexSelected(0);

            this.notificationService.success(this.translate.instant('COMMON.SAVED'), this.translate.instant('PROCEDIMIENTOS.MSG.TAB_DELETED'), 5000);
        },
        error: (err) => {
          //console.log(err);
        }
      }
    );
  }

  initPestania(): FormGroup {
    var ordenMax: number = 1;
    if (this.pestanias?.controls?.length > 0) {
      this.pestanias.controls.forEach(element => {
        ordenMax = element.get('orden')?.value >= ordenMax ? element.get('orden').value + 1 : ordenMax;
      });
    }
    return this.formBuilder.group({
      id: [null],
      nombre: ['', Validators.required],
      titulo: [''],
      tagId: ['', [Validators.required, Validators.pattern('^[A-z,0-9]{1,255}$')]],
      orden: [ordenMax, Validators.required],
      visible: [false, Validators.required],
      campos: this.formBuilder.array([])
    });
  }

  pestaniaActiva(): boolean {
    if (this.pestaniaForm && Object.keys(this.pestaniaForm?.controls)) {
      return true;
    }
    return false;
  }

  campoActivo(): boolean {
    if (this.campoForm && Object.keys(this.campoForm?.controls).length > 0) {
      return true;
    }
    return false;
  }

  pestaniaTieneCampos(): boolean {
    const campos = this.pestaniaForm.get('campos') as FormArray;

    if (campos && campos.length > 0) {
      return true;
    }
    return false;
  }

  addCampo(pestaniaIndex: number): void {
    const campos = this.pestanias.at(pestaniaIndex).get('campos') as FormArray;
    campos.push(this.initCampo());
  }

  addCampoGroup(): void {
    const campos = this.pestanias.at(this.tabIndexSelected).get('campos') as FormArray;

    var proc: any = campos.controls.findIndex(campo => this.asFormGroup(campo).controls['id']?.value == this.campoForm.controls['id']?.value);
    if (proc >= 0) {
      campos[proc] = this.campoForm;
    }
    else {
      campos.push(this.campoForm);
    }
  }

  removeCampo(campoEnt: FormGroup): void {
    const campos: FormArray = this.pestanias.at(this.tabIndexSelected).get('campos') as FormArray;
    if (campos) {
      var proc: any = campos.controls.findIndex(campo => {
        return campo.get('id')?.value == campoEnt.controls['id']?.value
      });
      if (proc >= 0) campos.removeAt(proc);
      this.procedimientosService.bajaCampoPestaniaProcedimiento(this.mapFormCampo(campoEnt)).subscribe(
        {
          next: (data) => {
            this.notificationService.success(this.translate.instant('COMMON.SAVED'), this.translate.instant('PROCEDIMIENTOS.MSG.FIELD_DELETED'), 5000);
            var orden: number = campoEnt.controls['orden'].value;
            campos.controls.forEach(element => {
              if (orden < element.get('orden')?.value) {
                element.get('orden')?.setValue(orden);
                orden = orden + 1;
                this.procedimientosService.guardaCampoPestaniaProcedimiento(this.procedimientoForm.controls['id'].value, this.pestaniaForm.controls['id'].value, this.mapFormCampo(this.campoForm)).subscribe(
                  {
                    next: (data) => {
                    },
                    error: (err) => {
                      //console.log(err);
                    }
                  }
                );
              }


            });
          },
          error: (err) => {
            //console.log(err);
          }
        }
      );
    }
  }
  sizeCampos: number = 0;
  getCamposPestania(): FormGroup[] {
    if (this.pestanias.at(this.tabIndexSelected)) {
      const campos: FormArray = this.pestanias.at(this.tabIndexSelected).get('campos') as FormArray;
      if (campos
        && campos) {
        this.sizeCampos = campos.length;
        return this.ordenaArrayCampos(campos).controls as FormGroup[];
      }
    }
    else {
      if (this.pestaniaForm
        && this.pestaniaForm.get('campos')) {
        this.sizeCampos = (this.pestaniaForm.get('campos') as FormArray).length;
        return this.ordenaArrayCampos((this.pestaniaForm.get('campos') as FormArray)).controls as FormGroup[];
      }
    }
  }

  asFormGroup(form: any): FormGroup {
    return form as FormGroup;
  }
  initCampo(): FormGroup {
    var ordenMax: number = 1;
    const campos = this.pestaniaForm.get('campos') as FormArray;
    if (campos && campos.length > 0) {
      campos.controls.forEach(element => {
        ordenMax = element.get('orden')?.value >= ordenMax ? element.get('orden').value + 1 : ordenMax;
      });
    }
    this.opcionForm = this.initOpcion();
    return this.formBuilder.group({
      id: [null],
      tipo: ['', Validators.required],
      label: [''],
      textoRepresentativo: [''],
      nombre: ['', Validators.required],
      orden: [ordenMax, Validators.required],
      visible: [false, Validators.required],
      habilitado: [true, Validators.required],
      tipovalidador: [''],
      patternvalidador: [''],
      obligatorio: [false, Validators.required],
      divClass: [''],
      nombreVariableDefecto: [''],
      nombreCampoDefecto: [''],
      nuevoListado: [false],
      modificarListado: [false],
      listadoSeleccionado: [''],
      listado: [''],
      opciones: this.formBuilder.array([]),
      tituloEnfatizado: ['']
    });
  }

  addOpcion(): void {
    this.opcionForm.valid
    if (this.opcionForm.valid) {
      if (!this.campoForm.controls['opciones']) {
        this.campoForm.addControl('opciones', this.formBuilder.array([]));
      }
      const opciones = this.campoForm.controls['opciones'] as FormArray;
      if (this.indexToEdit != undefined) {
        opciones.setControl(this.indexToEdit, this.opcionForm);
        this.indexToEdit = undefined
      } else {
        opciones.push(this.opcionForm);
      }
      this.opcionForm = this.initOpcion();
    }
  }

  removeOpcion(opcionIndex: number): void {
    if (!this.campoForm.controls['opciones']) {
      this.campoForm.addControl('opciones', this.formBuilder.array([]));
    }
    const opciones = this.campoForm.controls['opciones'] as FormArray;
    opciones.removeAt(opcionIndex);
  }

  initOpcion(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      nombre: ['', Validators.required],
      valor: ['', Validators.required],
      idBaseDatos: [null]
    });
  }

  muestraPestanias(): void {
    if (this.procedimientoForm.valid) {
      this.procedimientosService.guardaProcedimiento(this.mapFormProcedimiento(this.procedimientoForm)).subscribe(
        {
          next: (data) => {
            if (data && data['id']) {
              this.procedimientoForm.patchValue({
                id: data['id']
              });
            }
            this.notificationService.success(this.translate.instant('COMMON.SAVED'), this.translate.instant('PROCEDIMIENTOS.MSG.SAVED'), 5000);
          },
          error: (err) => {
            //console.log(err);
          }
        }
      );
      this.pestaniaForm = this.initPestania();
      this.panelDatosTramite = false;
      this.panelPestanias = true;
      this.pasoTramite = 'datosPestanias';
      this.tabIndexSelected = this.pestanias?.length;
    } else {
      // Marcar todos los campos como tocados para mostrar mensajes de error
      this.procedimientoForm.markAllAsTouched();
    }
  }
  nuevaPestania() {
    this.pestaniaForm = this.initPestania();
    this.panelDatosTramite = false;
    this.panelPestanias = true;
    this.pasoTramite = 'datosPestanias';
    this.tabIndexSelected = this.pestanias?.length;
  }

  mapFormProcedimiento(form: FormGroup): ProcedimientoDinamico {
    let proc = {} as ProcedimientoDinamico;
    if (form != undefined) {
      proc.id = form.controls['id']?.value;
      proc.codigo = form.controls['codigo']?.value;
      proc.sia = form.controls['sia']?.value;
      proc.nombre = form.controls['nombre']?.value;
      proc.visible = form.controls['visible']?.value;
      proc.identificador = form.controls['identificador']?.value;
      proc.link_ayuda = form.controls['link_ayuda']?.value;
      proc.link_ordenanza = form.controls['link_ordenanza']?.value;
      proc.departamento = form.controls['departamento']?.value;
      proc.custom = form.controls['custom']?.value;
    }
    return proc;
  }
  mapFormPestania(form: FormGroup): Pestania {
    let pest = {} as Pestania;
    if (form != undefined) {
      pest.id = form.controls['id']?.value;
      pest.nombre = form.controls['nombre']?.value;
      pest.titulo = form.controls['titulo']?.value;
      pest.tagId = form.controls['tagId']?.value;
      pest.orden = form.controls['orden']?.value;
      pest.visible = form.controls['visible']?.value;
    }
    return pest;
  }
  mapFormCampo(form: FormGroup): Campo {
    let campo = {} as Campo;
    if (form != undefined) {
      console.log("Form: ", form);

      campo.id = form.controls['id']?.value;
      campo.tipo = form.controls['tipo']?.value;
      campo.label = form.controls['label']?.value;
      campo.textoRepresentativo = form.controls['textoRepresentativo']?.value;
      campo.nombre = form.controls['nombre']?.value;
      campo.valor = form.controls['valor']?.value;
      campo.orden = form.controls['orden']?.value;
      campo.visible = form.controls['visible']?.value;
      campo.habilitado = form.controls['habilitado']?.value;
      campo.tipovalidador = form.controls['tipovalidador']?.value;
      campo.patternvalidador = form.controls['patternvalidador']?.value;
      campo.obligatorio = form.controls['obligatorio']?.value;
      campo.divClass = form.controls['divClass']?.value;
      campo.nombreVariableDefecto = form.controls['nombreVariableDefecto']?.value;
      campo.nombreCampoDefecto = form.controls['nombreCampoDefecto']?.value;
      campo.listado = form.controls['listado']?.value;
      campo.listadoSeleccionado = form.controls['listadoSeleccionado']?.value;
      campo.tituloEnfatizado = form.controls['tituloEnfatizado']?.value;
      campo.opcionesListado = this.mapOpciones(form);
    }
    return campo;
  }

  mapOpciones(campo: FormGroup): Opcion[] {
    let opciones: Opcion[] = [];
    if (campo.controls['opciones']) {
      var opcionArr = (campo.controls['opciones'] as FormArray).controls as FormGroup[];
      opcionArr.forEach(opc => {
        console.log(opc)
        var opcion: Opcion = {} as Opcion;
        opcion.label = opc.controls['nombre']?.value;
        opcion.id = opc.controls['valor']?.value;
        opcion.idBaseDatos = opc.controls['idBaseDatos']?.value;
        opciones.push(opcion);
      });
    }
    return opciones;
  }
  aniadirCampos(): void {
    if (this.pestaniaForm.valid) {
      this.campoForm = this.initCampo();
      this.panelCampo = true;
      this.pasoTramite = 'datosCampo';
    } else {
      // Marcar todos los campos como tocados para mostrar mensajes de error
      this.procedimientoForm.markAllAsTouched();
    }
  }


  guardaPestania(): void {
    if (this.pestaniaForm.valid) {
      this.procedimientosService.guardaPestaniaProcedimiento(this.procedimientoForm.controls['id'].value, this.mapFormPestania(this.pestaniaForm)).subscribe(
        {
          next: (data) => {
            if (data && data['id']) {

              this.pestaniaForm.patchValue({
                id: data['id']
              });
              this.notificationService.success(this.translate.instant('COMMON.SAVED'), this.translate.instant('PROCEDIMIENTOS.MSG.TAB_SAVED'), 5000);
            }
            this.addPestaniaGroup();
            this.aniadirCampos();
          },
          error: (err) => {
            //console.log(err);
          }
        }
      );
    }
    else {
      this.procedimientoForm.markAllAsTouched();
    }
  }
  guardaCampo(): void {
    console.log("Es el formulario válido: ", this.campoForm.valid);

    if (this.campoForm.valid) {
      console.log("Entro en if de guardar campos");

      this.procedimientosService.guardaCampoPestaniaProcedimiento(this.procedimientoForm.controls['id'].value, this.pestaniaForm.controls['id'].value, this.mapFormCampo(this.campoForm)).subscribe(
        {
          next: (data) => {
            if (data && data['id']) {
              this.campoForm.patchValue({
                id: data['id']
              });
              this.notificationService.success(this.translate.instant('COMMON.SAVED'), this.translate.instant('PROCEDIMIENTOS.MSG.FIELD_SAVED'), 5000);
            }
            if (this.campoForm.controls['nuevoListado'] != undefined) this.campoForm.controls['nuevoListado'].setValue(false);
            if (this.campoForm.controls['opciones']) {
              this.getListasDisponibles();
            }
            this.addCampoGroup();
            this.campoForm = this.initCampo();
          },
          error: (err) => {
            //console.log(err);
          }
        }
      );

      this.pasoTramite = 'datosCampo';
    }
    else {
      this.campoForm.markAllAsTouched();
    }
  }

  cancelaPestania(): void {

    if (this.pestanias?.controls?.length > 0) {
      this.pestaniaForm = this.pestanias.controls[0] as FormGroup;
    }
    else {
      this.pestaniaForm = this.formBuilder.group({});
      this.pasoTramite = 'datosTramite';
      this.panelDatosTramite = true;
    }
  }
  cancelaCampo(): void {
    this.campoForm = this.formBuilder.group({});
  }
  onSubmit(): void {
    if (this.procedimientoForm.valid) {
      // Realizar acción con los datos del formulario
    } else {
      // Marcar todos los campos como tocados para mostrar mensajes de error
      this.procedimientoForm.markAllAsTouched();
    }
  }
  actualizaIndexSelectedB(n: number, reseteaCampo: boolean) {
    this.tabIndexSelected = n;
    if (this.pestanias) {
      this.pestaniaForm = this.pestanias.at(this.tabIndexSelected) as FormGroup;
      if (reseteaCampo) {
        this.campoForm = this.initCampo();
      }
    }
  }
  actualizaIndexSelected(n: number) {
    this.actualizaIndexSelectedB(n, true);
  }
  editCampo(control: FormGroup) {
    this.panelCampo = true;
    this.campoForm = control;
    console.log(this.opcionForm)
    this.pasoTramite = 'datosCampo';
    if (control.value.tipo == "select" || control.value.tipo == "multiselect") {
      this.campoForm.addControl('opciones', this.formBuilder.array([]));
      this.opcionForm = this.initOpcion();
    }
  }

  formatoFecha(date) {
    if (date) {
      let month = (date[1] < 10) ? '0' + date[1] : date[1];
      let day = (date[2] < 10) ? '0' + date[2] : date[2];
      let year = date[0];
      let hour = (date[3] < 10) ? '0' + date[3] : date[3];
      let min = (date[4] < 10) ? '0' + date[4] : date[4];
      let seg = (date[5]) ? ((date[5] < 10) ? '0' + date[5] : date[5]) : '00';
      return [year, month, day].join('-').concat('T' + [hour, min, seg].join(':') + '.000Z');
    }
    return ''
  }

  formatDate(date: Date) {
    return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
  }

  subirOrdenCampo(control: FormGroup) {
    if (this.pestaniaActual.controls['campos']) {
      var campos = (this.pestaniaActual.controls['campos'] as FormArray).controls as FormGroup[];
      var indexCampoActual: any = campos.findIndex(campo => this.asFormGroup(campo).controls['orden']?.value == control.get('orden')?.value);
      var indexCampoBuscar: any = campos.findIndex(campo => this.asFormGroup(campo).controls['orden']?.value == (control.get('orden')?.value - 1));
      campos[indexCampoBuscar].get('orden').patchValue(control.get('orden').value);
      campos[indexCampoActual].get('orden').patchValue(control.get('orden').value - 1);
      this.almacenaCampo(campos[indexCampoBuscar]);
      this.almacenaCampo(campos[indexCampoActual]);
    }
  }
  bajarOrdenCampo(control: FormGroup) {
    if (this.pestaniaActual.controls['campos']) {
      var campos = (this.pestaniaActual.controls['campos'] as FormArray).controls as FormGroup[];
      var indexCampoActual: any = campos.findIndex(campo => this.asFormGroup(campo).controls['orden']?.value == control.get('orden')?.value);
      var indexCampoBuscar: any = campos.findIndex(campo => this.asFormGroup(campo).controls['orden']?.value == (control.get('orden')?.value + 1));
      campos[indexCampoBuscar].get('orden').patchValue(control.get('orden').value);
      campos[indexCampoActual].get('orden').patchValue(control.get('orden').value + 1);

      this.almacenaCampo(campos[indexCampoBuscar]);
      this.almacenaCampo(campos[indexCampoActual]);

    }
  }
  almacenaCampo(campo: FormGroup) {
    this.procedimientosService.guardaCampoPestaniaProcedimiento(
      this.procedimientoForm.controls['id'].value,
      this.pestaniaActual.controls['id'].value,
      this.mapFormCampo(campo))
      .subscribe(
        {
          next: (data) => { },
          error: (err) => { }
        }
      );
  }
  getOpcionesCampo(): FormGroup[] {
    if (this.campoForm
      && this.campoForm.get('opciones')) {
      //this.sizeCampos = (this.pestaniaForm .get('campos') as FormArray).length;
      return (this.campoForm.get('opciones') as FormArray).controls as FormGroup[];
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.pestanias.controls, event.previousIndex, event.currentIndex);
    this.pestanias.controls.forEach((element, index) => {
      element.get('orden')?.setValue(index + 1);
      this.procedimientosService.guardaPestaniaProcedimiento(this.procedimientoForm.controls['id'].value, this.mapFormPestania(element as FormGroup)).subscribe(
        {
          next: (data) => {
          },
          error: (err) => {
          }
        }
      );
    });
  }
  dropCampo(event: CdkDragDrop<string[]>) {
    if (this.pestaniaActual.controls['campos']) {
      moveItemInArray((this.pestaniaActual.controls['campos'] as FormArray).controls, event.previousIndex, event.currentIndex);
      (this.pestaniaActual.controls['campos'] as FormArray).controls.forEach((element: FormGroup, index) => {
        element.get('orden')?.setValue(index + 1);
        this.almacenaCampo(element);
      });
    }
  }



  editOpcion(index): void {
    let selectedGroup = this.getOpcionesCampo()[index];
    this.opcionForm.controls['valor'].setValue(selectedGroup['controls']['valor']?.value)
    this.opcionForm.controls['nombre'].setValue(selectedGroup['controls']['nombre']?.value)
    this.opcionForm.controls['idBaseDatos'].setValue(selectedGroup['controls']['idBaseDatos']?.value)
    this.indexToEdit = index;

  }


  async onSelectChange(event) {
    if (event.target.value != '' && event.target.value != undefined) {
      let lista = await this.getListadoNombreVariableByargumento(event.target.value)
      this.campoForm.controls['listado'].setValue(event.target.value)
      this.campoForm.addControl('opciones', this.formBuilder.array([]));


      let firstTime = true;
      lista.forEach(element => {
        console.log(element)
        if (element.lista != undefined) {
          const opciones = this.campoForm.controls['opciones'] as FormArray;
          const nuevaOpcion = this.formBuilder.group({
            id: [null],
            nombre: [element.nombre],
            valor: [element.valor],
            idBaseDatos: [element.id]
          });

          if (firstTime) {
            opciones.clear();
            firstTime = false
          }
          opciones.push(nuevaOpcion);
          console.log(opciones)
        }
      });
    } else {
      const opciones = this.campoForm.controls['opciones'] as FormArray;
      opciones.clear();
    }

  }

  onCheckboxnuevoListado(event) {
    if (event.checked) {
      this.campoForm.controls['listadoSeleccionado'].reset();
      const opciones = this.campoForm.controls['opciones'] as FormArray;
      opciones.clear();
      this.campoForm.controls['modificarListado']?.setValue(false);
      this.campoForm.controls['listadoSeleccionado']?.setErrors(null);
      this.campoForm.controls['listadoSeleccionado']?.setValidators(null);
      this.campoForm.controls['listadoSeleccionado']?.updateValueAndValidity();
    }
  }



  onCheckboxmodificarListado(event) {
    if (event.checked) {
      this.campoForm.controls['listado'].setValue('')
      this.campoForm.controls['listado'].reset();
      const opciones = this.campoForm.controls['opciones'] as FormArray;
      opciones.clear();
      this.campoForm.controls['nuevoListado']?.setValue(false)
    }
  }

  cargarMas() {
    const newSize = this.paginator.pageSize + 10;
    this.paginator.pageSize = newSize;
    this.dataSource.paginator = this.paginator;
  }
}